import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, throwError } from 'rxjs';

// INTERFACES
import { OptionInterface } from '../../interfaces/common.interface';
import { ITagOld } from '../../interfaces/tag.interface';

// SERVICES
import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class TagApiService {
  private readonly _tags = new BehaviorSubject<OptionInterface[]>(
    <OptionInterface[]>[],
  );
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);

  tags$ = this._tags.asObservable();
  loading$ = this._loading.asObservable();
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getTags(
    params :{ [param :string] :string | string[] },
    cache :boolean = false,
  ) :Subscription {
    if (this._loading.value) return;

    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV1}/product-tags`, {
        params,
        cache,
      })
      .subscribe({
        next: (response :any) => {
          if (response?.length > 0) {
            const formattedData = response.map((row :ITagOld) => {
              return {
                value: row.id,
                label: row.name,
              };
            });
            this._tags.next(formattedData);
          }
          this._loading.next(false);
        },
        error: (error :any) => {
          this._loading.next(false);

          return throwError(() => new Error(error));
        },
      });
  }

  replaceBulk(data :{
    taggableType :string;
    taggableIds :string[];
    tagIds :any[];
  }) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/taggable/replace-bulk`,
      body: data,
    });
  }
}
